import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TruthSection } from './components/TruthSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { StorySection } from './components/StorySection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { ResultsSection } from './components/ResultsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TruthSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <StorySection data-id="element-8" />
        <FeaturesSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <ResultsSection data-id="element-11" />
        <CtaSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}